import { Warehouse } from "../types/warehouse";
import { get } from "./fetch.core";

export async function listWarehouse() {
  // as an admin
  const res = await get<Warehouse[]>("/pos/warehouse/list");
  return res.data;
}

export async function getRetailWarehouse(id: string) {
  const res = await get<any>(`/pos/warehouse/get?retailShopId=${id}`);
  return res.data;
}
